module.exports = {
    ctaTypeToNameMap: {
        'url': 'URL',
        'mobile': 'Number',
        'email': 'Email'
    },
    subTypeToNameMap: {
        'lu': 'Long URL',
        'apk': 'APK',
        'wp': 'Whatsapp',
        'sd': 'Short Domain',
        'mob': 'Mobile',
        'll': 'Landline',
        'tf': 'Tollfree',
        'sc': 'Short code',
        'email': 'Email'
    },
    urlProtocols: [{ label: 'HTTPS', value: 'https' }, { label: 'HTTP', value: 'http' }],
    domainStatusMap: {
        '1': 'Approved',
        '0': 'Pending',
        '-1': 'Rejected'
    },
    whitelistStatusMap: {
        '1': 'Whitelisted',
        '0': 'Pending',
        '-1': 'Blacklisted'
    },
    lengths: [6],
    CTA: {
        URL: 'url',
        EMAIL: 'email',
        MOBILE: 'mobile'
    },
    CTA_NUMBER: {
        Mobile: 'mob',
        Landline: 'll',
        Tollfree: 'tf',
        Others: 'others'
    },
    protocolOptions: [{ label: 'https', value: 'https://' }, { label: 'http', value: 'http://' }]
}
